<section class="dashboard_content_sec">
    <div class="dashboard_bred_crumb">
        <ul>
            <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
            <li [routerLink]="['/profile/job-listing']">Job Listing</li>
            <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
            <li>Applicants</li>
        </ul>
    </div>

    <section class="master_add_sec  ">
        <div class="dashBoard-joblist-sec">
            <div class="job-box-company-detail-dashboard d-flex mb-4">
                <div>
                    <div class="jobcompanyLogo"
                        style="background-color: #d9d9d9 !important;border-radius: 50% !important;">
                        <img *ngIf="singleJob?.logo" src="{{singleJob?.logo}}">
                    </div>
                </div>
                <div class="ml-3">
                    <h3>{{singleJob?.title}}</h3>
                    <h4>{{singleJob?.company_name}}</h4>
                    <h4>{{singleJob?.location}}</h4>

                </div>
                <div class="d-flex align-self-baseline flex-column ml-auto text-right">
                    <div class="ml-auto">
                        <button mat-icon-button *ngIf="loginDetails.type !== 'ADMIN'" [matMenuTriggerFor]="menu1"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #menu1="matMenu" class="table-action-btn">

                            <button type="button" class="view" mat-menu-item
                                [routerLink]="['/jobseek/jobseeks/popular', singleJob?.id]">
                                <span>Preview</span>
                            </button>

                        </mat-menu>
                    </div>

                    <p class="mt-5">Created : {{singleJob?.created_at | date : 'dd-MM-yyyy'}}</p>
                </div>
            </div>
            <span class="EmploymentType" *ngIf="singleJob?.TypeofEmployment">
                <span class="fullTime" *ngFor="let type of singleJob?.TypeofEmployment">
                    {{ type }}
                </span>
            </span>
            <!-- <div class="jobDetailTextStyle mt-4">{{singleJob.description}}</div>  -->

            <div class="d-flex" style="margin-top:15px">
                <div class="mr-auto" style="min-width: 180px;">
                    <div class="orgThemeBtn mr-2" *ngIf="singleJob?.status === 'EXPIRED'">EXPIRED</div>
                    <div class="orgThemeBtn mr-2" *ngIf="singleJob?.status === 'DRAFT'">DRAFT</div>
                    <div class="orgThemeBtn mr-2"
                        *ngIf="singleJob?.status === 'APPROVE' && singleJob?.active_status === 'ACTIVE'"> ACTIVE</div>
                    <div class="orgThemeBtn mr-2"
                        *ngIf="singleJob?.status === 'APPROVE' && singleJob?.active_status === 'INACTIVE'">INACTIVE
                    </div>
                    <div class="orgThemeBtn mr-2" *ngIf="singleJob?.status === 'PENDING'">PENDING APPROVAL</div>
                    <div class="orgThemeBtn mr-2" *ngIf="singleJob?.status === 'REJECT'">REJECTED</div>


                    <ng-template #emptySpace>
                        <!-- Empty div just to hold the space -->
                        <div style="height: 36px;"></div>
                    </ng-template>
                </div>

                <!-- <div class="orgThemeBtn mr-2"> Applicants</div> -->
                <div class="blueThemeBtn" [routerLink]="['/jobseek/jobseeks/popular', singleJob?.id]">View Details</div>

            </div>
        </div>

    </section>

    <section class="master_add_sec">

        <hr>
        <mat-tab-group class="custom-tab-group" animationDuration="0ms" [(selectedIndex)]="selectedTabIndex"
            (selectedTabChange)="onTabChange($event)">
            <mat-tab *ngFor="let tab of tabs"
                [label]="tab.status === 'ENQUIRY' ? tab.label : (tab.label + ' (' + tab.count + ')')">
                <ng-template matTabContent>
                    <div class="tab-scroll-body" infiniteScroll [infiniteScrollDistance]="2"
                        [infiniteScrollThrottle]="150" (scrolled)="fetchApplicants()">
                        <div *ngIf="applicantsList?.length; else noData">

                            <div class="appliedApplicantList" *ngFor="let x of applicantsList">
                                <div class="applicantListItem">

                                    <div class="d-flex">
                                        <div class="applicants-img mr-3">
                                            <img *ngIf="x.dental_professional?.profile_image?.url; else showLetter"
                                                src="{{x.dental_professional?.profile_image?.url}}">
                                            <ng-template #showLetter>
                                                <div class="fallback-avatar">
                                                    <span class="text-initials"> {{
                                                        getInitial(x?.dental_professional?.name) }} </span>
                                                </div>
                                            </ng-template>

                                        </div>

                                        <div class="applicant-name">
                                            {{x?.dental_professional?.name}}</div>
                                        <div class="d-flex align-self-baseline flex-column ml-auto text-right applicant-action"
                                            *ngIf="tab?.status !== 'ENQUIRY'">
                                            <div class="mb-auto ml-auto">
                                                <button mat-icon-button
                                                    *ngIf="x?.status && loginDetails?.type !== 'ADMIN'"
                                                    [matMenuTriggerFor]="menu">
                                                    <mat-icon>more_horiz</mat-icon>
                                                </button>
                                                <mat-menu #menu="matMenu" class="table-action-btn">
                                                    <button type="button" class="view"
                                                        *ngIf="x?.status !== 'SHORTLISTED' " mat-menu-item
                                                        (click)="$event.stopPropagation(); updateApplicantStatus(x.id,'SHORTLISTED')">

                                                        <span> Shortlisted </span>
                                                    </button>
                                                    <button type="button" class="view"
                                                        *ngIf="x?.status !== 'INTERVIEWS' " mat-menu-item
                                                        (click)="$event.stopPropagation(); updateApplicantStatus(x.id,'INTERVIEWS')">

                                                        <span> Organize Interview</span>
                                                    </button>
                                                    <button type="button" class="view" *ngIf="x?.status !== 'ACCEPTED' "
                                                        mat-menu-item
                                                        (click)="$event.stopPropagation(); updateApplicantStatus(x.id,'ACCEPTED')">

                                                        <span>Accept</span>
                                                    </button>
                                                    <button type="button" class="view" *ngIf="x?.status !== 'DECLINED' "
                                                        mat-menu-item
                                                        (click)="$event.stopPropagation(); updateApplicantStatus(x.id,'DECLINED')">

                                                        <span>Decline</span>
                                                    </button>

                                                </mat-menu>
                                            </div>

                                            <!-- <p class="mt-1">05 sep 2020</p> -->
                                        </div>

                                    </div>

                                    <!-- <div class="jobDetailTextStyle mt-1"><b>Dentist</b></div> -->

                                    <div class="flexCon similarJobIcoTex" *ngIf="x?.job_profiles?.country">
                                        <div style="width: 30px;"><img
                                                src="../../../../../assets/images/locationPin.svg" alt=""></div>
                                        {{x?.job_profiles?.country}}
                                    </div>
                                    <hr>
                                    <div style="margin-bottom: 10px;">
                                        <span *ngIf="x?.status" class="status-applicants">{{x?.status}} </span>
                                        <span *ngIf="!x?.status" class="status-applicants"> ENQUIRY</span>
                                    </div>

                                    <div class="d-flex">
                                        <div class="mr-2" *ngIf="x?.attachments || x?.job_profiles?.upload_resume[0] ">
                                            <button mat-stroked-button
                                                (click)="feeddocumentView(x?.attachments || x?.job_profiles?.upload_resume[0])">
                                                Resume
                                            </button>
                                        </div>
                                        <div class="mr-2">
                                            <button mat-stroked-button (click)="toggleAccordion(x)">
                                                Message
                                            </button>

                                        </div>

                                        <div class="mr-2">
                                            <button mat-stroked-button (click)="EnquiryAcoordion(x)">
                                                Enquiry
                                            </button>

                                        </div>
                                        <!-- <div class="orgThemeBtn ">Send Job</div> -->

                                    </div>

                                    <!-- Accordion for Messages -->
                                    <div class="message-accordion" *ngIf="openAccordionId === x?.id">
                                        <div class="messages-container">
                                            <!-- Loop through messages -->
                                            <div *ngIf="loaderMessage"
                                                class="custom-loader custom_logo_loader no-datas">
                                                <img src='../../../../../assets/images2/loader.gif' alt="loading"
                                                    style="width: 10%;" />
                                            </div>
                                            <div *ngIf="!loaderMessage">
                                                <ng-container *ngIf="DisplayMessage?.length > 0; else noMessage">
                                                    <div *ngFor="let message of DisplayMessage"
                                                        [ngClass]="message?.message_from === loginDetails?.id ? 'message-right' : 'message-left'">

                                                        <div class="message-bubble">
                                                            <div class="message-header">
                                                                <!-- <img class="profile-image"  [src]="message?.message_from === loginDetails?.id ? singleJob?.logo : x.dental_professional?.profile_image?.url"> -->
                                                                <!-- Sender is me -->
                                                                <ng-container
                                                                    *ngIf="message?.message_from === singleJob?.dental_supplier_id || message?.message_from === singleJob?.dental_practice_id">
                                                                    <ng-container
                                                                        *ngIf="singleJob?.logo; else companyInitials">
                                                                        <img class="profile-image"
                                                                            [src]="singleJob?.logo">
                                                                    </ng-container>
                                                                    <ng-template #companyInitials>
                                                                        <div class="profile-initials"
                                                                            style="background-color:#ef6a30 ;">
                                                                            <span class="text-initials"> {{
                                                                                getInitial(singleJob?.company_name) }}
                                                                            </span>
                                                                        </div>
                                                                    </ng-template>
                                                                </ng-container>

                                                                <!-- Sender is dental professional -->
                                                                <ng-container
                                                                    *ngIf="message?.message_from !== singleJob?.dental_supplier_id && message?.message_from !== singleJob?.dental_practice_id">
                                                                    <ng-container
                                                                        *ngIf="x?.dental_professional?.profile_image?.url; else profInitials">
                                                                        <img class="profile-image"
                                                                            [src]="x?.dental_professional?.profile_image?.url">
                                                                    </ng-container>
                                                                    <ng-template #profInitials>
                                                                        <div class="profile-initials"
                                                                            style="background-color:#007bff;">
                                                                            <span class="text-initials"> {{
                                                                                getInitial(x?.dental_professional?.name)
                                                                                }} </span>
                                                                        </div>
                                                                    </ng-template>
                                                                </ng-container>

                                                                <span class="message-date">{{ message?.created_at | date
                                                                    :'medium' }} </span>
                                                                <button mat-icon-button
                                                                    *ngIf="message?.message_from === loginDetails?.id && !message?.deleted_status "
                                                                    [matMenuTriggerFor]="message1"
                                                                    (click)="$event.stopPropagation()">
                                                                    <mat-icon>more_horiz</mat-icon>
                                                                </button>
                                                            </div>

                                                            <div class="message-data">
                                                                <p class="message-text"
                                                                    *ngIf="!message?.deleted_status">{{
                                                                    message?.message }}</p>
                                                                <p class="message-text" *ngIf="message?.deleted_status">
                                                                    This
                                                                    message was deleted </p>
                                                            </div>
                                                            <p class="message-date"
                                                                *ngIf="!message?.deleted_status && message?.created_at !== message.updated_at ">
                                                                Edited
                                                            </p>

                                                        </div>



                                                        <mat-menu #message1="matMenu" class="table-action-btn">

                                                            <button type="button" class="view" mat-menu-item
                                                                (click)="editMessage(message)">
                                                                <span>Edit</span>
                                                            </button>
                                                            <button type="button" class="view" mat-menu-item
                                                                (click)="deleteMessage(message?.id)">
                                                                <span>Delete</span>
                                                            </button>

                                                        </mat-menu>

                                                    </div>
                                                </ng-container>
                                            </div>
                                            <ng-template #noMessage>
                                                <div class="no-datas">
                                                    No messages
                                                </div>
                                            </ng-template>
                                        </div>
                                        <div class="message-input-container" *ngIf="loginDetails.type !== 'ADMIN'">
                                            <input type="text" [(ngModel)]="newMessage"
                                                placeholder="Type a message..." />
                                            <!-- <button class="send-button" (click)="sendMessage(x)">Send</button> -->
                                            <button class="send-button"
                                                (click)="EditedMessageId ? UpdateMessage(EditedMessageId) :sendMessage(x)">
                                                <mat-icon class="send-icon">send</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Accordion Enquiry -->
                                    <div class="message-accordion" *ngIf="openEnquiryAccordionId === x?.id"
                                        style="min-height: 100px; overflow-y: auto;">
                                        <div class="messages-container">

                                            <div *ngIf="loaderEnquiry"
                                                class="custom-loader custom_logo_loader no-datas">
                                                <img src='../../../../../assets/images2/loader.gif' alt="loading"
                                                    style="width: 10%;" />
                                            </div>
                                            <div *ngIf="!loaderEnquiry">
                                                <ng-container *ngIf="enquiryMessage?.length > 0; else noEnquiry">
                                                    <div *ngFor="let enquiry of enquiryMessage">
                                                        <div class="message-right">
                                                            <div class="message-bubble">
                                                                <div class="message-header">
                                                                    <img class="profile-image"
                                                                        *ngIf="x?.dental_professional?.profile_image?.url; else profInitialsEnquiry"
                                                                        [src]="x?.dental_professional?.profile_image?.url">

                                                                    <ng-template #profInitialsEnquiry>
                                                                        <div class="profile-initials"
                                                                            style="background-color:#007bff;">
                                                                            <span class="text-initials"> {{
                                                                                getInitial(x?.dental_professional?.name)
                                                                                }} </span>
                                                                        </div>
                                                                    </ng-template>

                                                                    <span class="message-date">{{ enquiry?.created_at |
                                                                        date
                                                                        :'medium' }} </span>
                                                                </div>

                                                                <div class="message-data">
                                                                    <p class="message-text">
                                                                        {{enquiry?.enquiry_description}}</p>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <ng-template #noEnquiry>
                                                <div class="no-datas">
                                                    No Enquiry
                                                </div>
                                            </ng-template>

                                        </div>
                                        <!-- <div *ngIf="enquiryMessage?.length === 0" style="max-height: 200px; overflow-y: auto;">
                              <p>Enquiry not found</p>
                            </div> -->
                                    </div>
                                </div>

                            </div>

                        </div>

                        <!-- Enquiry -->

                        <!-- <ng-template #noEnquiry>
            <p>No Enquiries</p>
          </ng-template> -->

                        <ng-template #noData>
                            <p *ngIf="tab.status === 'ALL' ">No Applicants found.</p>
                            <p *ngIf="tab.status === 'APPLIED' ">No applicants found.</p>
                            <p *ngIf="tab.status === 'SHORTLISTED' ">No Shortlisted found.</p>
                            <p *ngIf="tab.status === 'INTERVIEWS' ">No Organized interviews found.</p>
                            <p *ngIf="tab.status === 'ACCEPTED' ">No Accepted found.</p>
                            <p *ngIf="tab.status === 'DECLINED' ">No Declined found.</p>
                            <p *ngIf="tab.status === 'ENQUIRY' ">No Enquiries found.</p>
                        </ng-template>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>



    </section>